export function export2Excel(columns, list, title) {
  list = JSON.parse(JSON.stringify(list))
  const tempData = []
  columns.forEach(column => {
    if (column.colspan) {
      column.data.forEach(col => {
        if (col.hasOwnProperty('toFixed')) {
          tempData.push(col)
        }
      })
    } else if (column.hasOwnProperty('toFixed')) {
      tempData.push(column)
    }
  })
  tempData.forEach(item => {
    list.forEach(obj => {
      if (!isNaN(obj[item.key])) {
        obj[item.key] = obj[item.key].toFixed(item['toFixed'])
      }
    })
  })
  require.ensure([], () => {
    const { export_json_to_excel } = require('./excel/Export2Excel');
    let tHeader = []
    let tHeader1 = []
    let filterVal = []
    if (!columns) {
      return;
    }
    columns.forEach(item => {
      if (item.colspan) {
        item.data.forEach(col => {
          tHeader1.push(col.title)
          filterVal.push(col.key)
        })
        tHeader.push({
          title: item.title,
          colspan: item.colspan
        })
        for (var i = 0; i < item.colspan - 1; i++) {
          tHeader.push("")
        }
      } else if (item.rowspan) {
        tHeader.push(item)
        filterVal.push(item.key)
        for (var j = 0; j < item.rowspan - 1; j++) {
          tHeader1.push("")
        }
      } else {
        tHeader.push(item.title)
        filterVal.push(item.key)
      }
    })
    const data = list.map(v => filterVal.map(j => v[j]))
    export_json_to_excel([tHeader, tHeader1], data, title);
  })
}